import Alcohol from "../../../../../images/posters/fbbc/best-practices/alcohol.webp";
import BodyFat from "../../../../../images/posters/fbbc/best-practices/body-fat.webp";
import ProteinSwap from "../../../../../images/posters/fbbc/best-practices/protein-swap.webp";
import RawVsCooked from "../../../../../images/posters/fbbc/best-practices/raw-vs-cooked.webp";
import FatLossPhase from "../../../../../images/posters/fbbc/best-practices/fat-loss-phase.webp";
import MuscleGainPhase from "../../../../../images/posters/fbbc/best-practices/muscle-gain-phase.webp";
import TransitionPhase from "../../../../../images/posters/fbbc/best-practices/transition-phase.webp";
import MaintenancePhase from "../../../../../images/posters/fbbc/best-practices/maintenance-phase.webp";
import DailyIntakeTrumpsWeekly from "../../../../../images/posters/fbbc/best-practices/daily-intake-trumps-weekly.webp";

const avatarSystemTools = [
  {
    "title": "Why Alcohol is Tracked Differently in the App",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Alcohol.mp4",
    "thumbnail": Alcohol,
    "length": "5:59"
  },
  {
    "title": "How Body Fat is Used at Check-ins",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Body+Fat.mp4",
    "thumbnail": BodyFat,
    "length": "10:08"
  },
  {
    "title": "Why Protein Can't Be Swapped in the App",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Protein+Importance.mp4",
    "thumbnail": ProteinSwap,
    "length": "6:41"
  },
  {
    "title": "Should Food Be Weighed Raw or Cooked?",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Raw+vs+Cooked.mp4",
    "thumbnail": RawVsCooked,
    "length": "6:07"
  },
  {
    "title": "Fat Loss Phase Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Fat+Loss+Phase.mp4",
    "thumbnail": FatLossPhase,
    "length": "12:04"
  },
  {
    "title": "Muscle Gain Phase Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Muscle+Gain+Phase.mp4",
    "thumbnail": MuscleGainPhase,
    "length": "13:20"
  },
  {
    "title": "Transition Phase Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Transition+Phase.mp4",
    "thumbnail": TransitionPhase,
    "length": "16:45"
  },
  {
    "title": "Maintenance Phase Best Practices",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Maintenance+Phase.mp4",
    "thumbnail": MaintenancePhase,
    "length": "10:19"
  },
  {
    "title": "Why Weekly Macro Intake Trumps Daily",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/FBBC+Daily+vs+Weekly.mp4",
    "thumbnail": DailyIntakeTrumpsWeekly,
    "length": "9:54"
  }
];

export default avatarSystemTools; 